"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { tv } from 'tailwind-variants';

const spinnerVariants = tv({
  base: "inline-block rounded-full border-2 border-solid animate-spin border-b-transparent border-l-transparent",
  variants: {
    size: {
      xs: "w-3 h-3",
      sm: "w-4 h-4",
      md: "w-6 h-6",
      lg: "w-8 h-8",
      xl: "w-12 h-12"
    },
    colorPalette: {
      gray: "border-gray-default"
    }
  },
  defaultVariants: {
    size: "md",
    colorPalette: "gray"
  }
});
const Spinner = forwardRef(
  ({ label = "Loading...", size, colorPalette, className, ...props }, ref) => /* @__PURE__ */ jsx("div", { ref, className: spinnerVariants({ size, colorPalette, className }), ...props, children: label && /* @__PURE__ */ jsx("span", { className: "sr-only", children: label }) })
);
Spinner.displayName = "Spinner";

export { Spinner };
